import { useStrictParams } from 'modules/core/hooks/useStrictParams'
import { ActivityCatalog } from 'modules/core/lib/activities/catalog'
import { useActivities } from 'modules/core/lib/activities/provider'

const ACTIVITY_IDS = {
  sendSurvey: 'trainings.sendSurvey' as const,
  deleteSurvey: 'trainings.deleteSurvey' as const,
  editSurveySettings: 'trainings.editSurveySettings' as const,
  saveAsTemplate: 'trainings.saveAsTemplate' as const,
} satisfies Record<string, ActivityCatalog>

export function useTrainingSurveyActions() {
  const { id, formId } = useStrictParams<'id' | 'formId'>()
  const { openActivity } = useActivities()

  const commonActivityData = {
    trainingId: id,
    formId: formId,
  }

  const actionKeyToActivity: Record<
    string,
    { activity: ActivityCatalog; data: typeof commonActivityData } | undefined
  > = {
    send: {
      activity: ACTIVITY_IDS.sendSurvey,
      data: commonActivityData,
    },
    edit: {
      activity: ACTIVITY_IDS.editSurveySettings,
      data: commonActivityData,
    },
    delete: {
      activity: ACTIVITY_IDS.deleteSurvey,
      data: commonActivityData,
    },
    edit_settings: {
      activity: ACTIVITY_IDS.editSurveySettings,
      data: commonActivityData,
    },
    save_template: {
      activity: ACTIVITY_IDS.saveAsTemplate,
      data: commonActivityData,
    },
  }

  const handleActionClick = (key: string) => {
    const activityConfig = actionKeyToActivity[key]
    if (activityConfig) {
      openActivity(activityConfig.activity, activityConfig.data)
    }
  }

  return {
    handleActionClick,
  }
}
